import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-select-with-search',
  templateUrl: './select-with-search.component.html',
  standalone: false
})
export class SelectWithSearchComponent implements OnInit, OnChanges {
  @ViewChild('doctorSelect') selectElem: MatSelect;
  @Input() filterFormGroup: UntypedFormGroup;
  @Input() sourcData: any[];
  @Input() isSubmitted: boolean;
  @Input() controlName: any;
  @Input() fieldLabel: String;
  @Input() keyTitle: any = 'name';
  @Input() multiple: boolean = true;
  @Input() hasApi: boolean = false;
  @Output() searchEvent = new EventEmitter<string>();
  @Output() setValueEvent = new EventEmitter<boolean>();
  @Output() scrollEvent = new EventEmitter<boolean>();
  @Input() pageCount: number;
  @Input() dataLoading: boolean;
  @Input() selectedItem: any;
  //
  @ViewChild('searchInput', { static: false })
  searchInput: ElementRef<HTMLInputElement>;
  searchControl = new UntypedFormControl();
  //
  constructor() { }

  ngOnInit(): void {
    this.searchControl.valueChanges.pipe(
      debounceTime(100),
      distinctUntilChanged()
    ).subscribe(value => {
      console.log(value)
      // Your code here
      this.applyFilter(value);
    });

  }

  ngOnChanges(changes: SimpleChanges): void {
    // console.log(changes)
    if (this.sourcData && this.sourcData.length) {
      console.log(this.selectedItem)
      if (
        this.selectedItem
        && (
          this.multiple && this.bindMatMultiSelect(this.selectedItem, this.sourcData).length ||
          !this.multiple && this.sourcData.find(item => item.id == Number(this.filterFormGroup.controls[this.controlName].value.id))
        )
      ) {
        // this.filterFormGroup.controls[this.controlName].updateValueAndValidity();
        // console.log(this.filterFormGroup.controls[this.controlName].value)
        this.filterFormGroup.controls[this.controlName].setValue(
          this.multiple ?
            this.bindMatMultiSelect(this.selectedItem, this.sourcData) :
            this.sourcData.find(item => item.id == Number(this.filterFormGroup.controls[this.controlName].value.id))
        );
      }
    }
    if (changes && changes['isSubmitted'] && changes['isSubmitted'].currentValue) {
      this.filterFormGroup.controls[this.controlName].markAllAsTouched();
    }
  }

  selectChanged(e: MatSelectChange) {
    console.log(e)
    this.selectedItem = e.value;
    this.setValueEvent.emit(true);
    console.log(this.selectedItem)
  }

  applyFilter(value: string) {
    const filterValue = value.toLowerCase();
    // console.log(value)
    if (this.hasApi) {
      this.searchEvent.emit(value);
    } else {
      this.sourcData.forEach((item) => {
        item.hidden = true;
        if (filterValue === '') {
          item.hidden = false;
        } else if (item[this.keyTitle].toLowerCase().includes(filterValue)) {
          item.hidden = false;
        }
      });
    }
  }

  openEvent(opened) {
    if (opened) {
      if (this.hasApi) {
        const panel = this.selectElem.panel?.nativeElement;
        if (panel) { panel.addEventListener('scroll', () => this.onScroll(panel)); }
      }
      setTimeout(() => { this.searchInput?.nativeElement.focus(); });
    } else {
      this.clearFilter();
    }
  }

  clearFilter() {
    this.searchInput.nativeElement.value = '';
    this.applyFilter('');
  }

  onScroll(panel: HTMLElement) {
    if (Math.round(panel.scrollTop + panel.clientHeight + 1) >= panel.scrollHeight && !this.dataLoading) {
      this.scrollEvent.emit(true);
    }
  }

  bindMatMultiSelect(data, parent) {
    const selectedList: any[] = [];
    if (parent && data) {
      parent.forEach(item => {
        if (data.some(obj => (obj.hasOwnProperty('id') ? obj.id : obj) === item.id)) {
          selectedList.push(item);
        }
      });
    }
    return selectedList;
  }

  hasError(controlName: string, errorName: string) {
    return this.filterFormGroup.controls[controlName].hasError(errorName);
  }
}
